export default __webpack_public_path__ + "static/media/bw_squat.a2377f29.svg";